const cookiebeleid = {
  seo: {
    title: "Cookiebeleid | Ramen Repair Eindhoven",
    description:
      "Welke cookies Ramen Repair Eindhoven gebruikt en hoe u uw voorkeuren beheert. Conform AVG en Nederlandse Telecommunicatiewet.",
    h1: "Cookiebeleid",
  },
  version: "Versie 1.0 — Laatst bijgewerkt: 28 mei 2026",
  sections: [
    {
      nr: "1",
      title: "Wat zijn cookies?",
      paragraphs: [
        "Cookies zijn kleine tekstbestanden die door een website worden opgeslagen op uw computer, tablet of smartphone wanneer u onze website bezoekt. Deze bestanden worden door uw webbrowser bewaard en helpen ons om de website correct te laten functioneren, uw voorkeuren te onthouden en het gebruik van onze website te analyseren.",
        "Cookies bevatten over het algemeen geen persoonlijk identificeerbare informatie, maar kunnen in combinatie met andere gegevens wel tot een profiel leiden. Wij gebruiken cookies uitsluitend voor de doeleinden die in dit cookiebeleid zijn beschreven.",
      ],
    },
    {
      nr: "2",
      title: "Soorten cookies die wij gebruiken",
      paragraphs: [
        "Wij maken onderscheid tussen verschillende soorten cookies, elk met een eigen doel en juridische basis. De toestemming die wij vragen is afhankelijk van het type cookie.",
      ],
      list: [
        "Functionele / technische cookies: Deze cookies zijn strikt noodzakelijk voor de werking van de website. Zij zorgen voor basisfunctionaliteit zoals het onthouden van uw sessie, taalvoorkeur en beveiligingsinstellingen. Functionele cookies worden zonder toestemming geplaatst op grond van artikel 6 lid 1 onder f AVG (gerechtvaardigd belang) en artikel 11.7a van de Telecommunicatiewet.",
        "Analytische cookies: Deze cookies verzamelen geaggregeerde statistische gegevens over het gebruik van onze website, zoals het aantal bezoekers, bezochte pagina's en bronnen van verkeer. Wij gebruiken Google Analytics met geanonimiseerd IP-adres. Analytische cookies worden alleen geplaatst na uw expliciete toestemming.",
        "Marketing cookies: Deze cookies worden gebruikt voor gepersonaliseerde advertenties, retargetingcampagnes en het meten van advertentieprestaties. Voorbeelden zijn het Google Ads-conversion-trackingcookie en het Meta Pixel-cookie. Marketing cookies worden uitsluitend geplaatst na uw uitdrukkelijke toestemming.",
      ],
    },
    {
      nr: "3",
      title: "Overzicht actieve cookies",
      paragraphs: [
        "Hieronder vindt u een volledig overzicht van alle cookies die op onze website actief zijn. Voor elk cookie vermelden wij de naam, het doel, het type, de bewaartermijn en de aanbieder.",
      ],
      table: {
        headers: ["Cookie naam", "Doel", "Type", "Bewaartermijn", "Provider"],
        rows: [
          ["session_id", "Gebruikerssessie", "Functioneel", "Sessie", "Eigen"],
          ["lang_pref", "Taalvoorkeur", "Functioneel", "1 jaar", "Eigen"],
          ["cookie-consent", "Onthoudt cookie-keuze", "Functioneel", "6 maanden", "Eigen"],
          ["_ga", "Google Analytics user ID", "Analytisch", "14 maanden", "Google"],
          ["_ga_*", "Google Analytics sessie", "Analytisch", "14 maanden", "Google"],
          ["_fbp", "Meta Pixel", "Marketing", "90 dagen", "Meta"],
          ["_gcl_au", "Google Ads conversion", "Marketing", "90 dagen", "Google"],
        ],
      },
    },
    {
      nr: "4",
      title: "Cookie-instellingen wijzigen",
      paragraphs: [
        "U kunt op elk gewenst moment uw cookievoorkeuren aanpassen. U heeft het recht om eerder gegeven toestemming voor analytische en marketingcookies in te trekken. Functionele cookies kunnen niet worden uitgeschakeld, omdat zij noodzakelijk zijn voor de werking van de website.",
        "Klik op onderstaande knop om uw cookievoorkeuren te beheren. De cookievoorkeurenmodal wordt geopend waarin u per cookietype uw voorkeur kunt aanpassen.",
      ],
      button: {
        text: "Cookievoorkeuren beheren",
        action: "open-cookie-modal",
      },
    },
    {
      nr: "5",
      title: "Cookies in uw browser uitschakelen",
      paragraphs: [
        "Naast het aanpassen van uw voorkeuren via onze website, kunt u cookies ook beheren via de instellingen van uw webbrowser. Hieronder vindt u instructies voor de meest gebruikte browsers.",
      ],
      links: [
        {
          text: "Google Chrome — Cookie-instellingen",
          url: "https://support.google.com/chrome/answer/95647",
        },
        {
          text: "Mozilla Firefox — Cookie-informatie",
          url: "https://support.mozilla.org/kb/cookies-informatie",
        },
        {
          text: "Apple Safari — Cookie-instellingen",
          url: "https://support.apple.com/nl-nl/guide/safari/sfri11471",
        },
        {
          text: "Microsoft Edge — Cookie-instellingen",
          url: "https://support.microsoft.com/microsoft-edge",
        },
      ],
    },
    {
      nr: "6",
      title: "Wijzigingen cookiebeleid",
      paragraphs: [
        "Wij behouden ons het recht voor om dit cookiebeleid te wijzigen. Wijzigingen worden met ingang van de in het beleid genoemde datum van kracht. Substantiële wijzigingen die invloed hebben op de cookies die wij plaatsen of de wijze waarop wij gegevens verzamelen, worden gecommuniceerd via de cookiebanner bij uw volgende bezoek aan de website.",
        "Wij raden u aan dit cookiebeleid regelmatig te raadplegen, zodat u op de hoogte blijft van de meest actuele versie en de cookies die wij gebruiken.",
      ],
    },
    {
      nr: "7",
      title: "Contact",
      paragraphs: [
        "Heeft u vragen over dit cookiebeleid, de cookies die wij gebruiken of de wijze waarop wij omgaan met cookiegegevens? Neem dan gerust contact met ons op.",
      ],
      list: [
        "E-mail: privacy@ramen-repair-eindhoven.nl",
        "Telefoon: 040 798 7470",
        "Adres: Marconilaan 3, 5612 HM Eindhoven",
        "Wij zijn bereikbaar van maandag tot zondag, 08:00 tot 20:00 uur.",
      ],
    },
  ],
  footer: {
    version: "Laatst bijgewerkt: 28 mei 2026. Versie 1.0.",
  },
};

export default cookiebeleid;